// Profile helpers (display name read/update). RLS already enforces user_id.

import { getSupabase } from "./client";
import { getUserId } from "./auth";

export interface MyProfile {
  displayName: string | null;
  friendCode:  string | null;
  createdAt:   string | null;
  avatarId:    string | null;
}

export async function fetchMyProfile(): Promise<MyProfile> {
  const sb = getSupabase();
  const uid = getUserId();
  if (!sb || !uid) return { displayName: null, friendCode: null, createdAt: null, avatarId: null };
  const { data, error } = await sb
    .from("profiles")
    .select("display_name, friend_code, created_at, avatar_id")
    .eq("user_id", uid)
    .maybeSingle();
  if (error) { console.warn("[profile] fetch failed", error); return { displayName: null, friendCode: null, createdAt: null, avatarId: null }; }
  return {
    displayName: data?.display_name ?? null,
    friendCode:  data?.friend_code ?? null,
    createdAt:   data?.created_at ?? null,
    avatarId:    data?.avatar_id ?? null
  };
}

export async function fetchMyDisplayName(): Promise<string | null> {
  const p = await fetchMyProfile();
  return p.displayName;
}

export async function updateMyDisplayName(name: string): Promise<{ error?: string }> {
  const sb = getSupabase();
  const uid = getUserId();
  if (!sb || !uid) return { error: "not signed in" };
  if (!/^[A-Za-z0-9_\- ]{2,24}$/.test(name)) {
    return { error: "2-24 chars, letters/numbers/spaces/-_ only" };
  }
  const { error } = await sb
    .from("profiles")
    .update({ display_name: name })
    .eq("user_id", uid);
  return error ? { error: error.message } : {};
}

export async function updateMyAvatar(avatarId: string): Promise<{ error?: string }> {
  const sb = getSupabase();
  const uid = getUserId();
  if (!sb || !uid) return { error: "not signed in" };
  const { error } = await sb
    .from("profiles")
    .update({ avatar_id: avatarId })
    .eq("user_id", uid);
  return error ? { error: error.message } : {};
}

export async function deleteMyAccount(): Promise<{ error?: string }> {
  const sb = getSupabase();
  if (!sb) return { error: "backend not configured" };
  const { error } = await sb.functions.invoke("delete-account", {});
  if (error) return { error: error.message };
  await sb.auth.signOut();
  return {};
}
